import { AppBar as MuiAppBar, Toolbar as MuiToolbar } from '@mui/material'
import PropTypes from 'prop-types'

const AppBar = ({ children, color = 'primary', position = 'fixed', sx = null }) => {
    return (
        <MuiAppBar
            color={color}
            elevation={4}
            position={position}
            sx={[...(Array.isArray(sx) ? sx : [sx])]}
        >
            <MuiToolbar>{children}</MuiToolbar>
        </MuiAppBar>
    )
}

AppBar.propTypes = {
    color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'transparent', 'error', 'info', 'success', 'warning']),
    position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default AppBar
